import { LoadableAfterPaint } from '@confluence/loadable';

export const SpaceNavigationContent = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SpaceNavigationContent" */ './SpaceNavigationContent.tsx'
			)
		).SpaceNavigationContent,
});
